import styled from 'styled-components';

import BaseCalendarIcon from '@edna/icons/calendar.svg';
import KeyboardArrowDownIcon from '@edna/icons/keyboardArrowDown.svg';

import {Calendar as BaseCalendar} from '../Calendar';
import {Overlay as BaseOverlay} from '../Dropdown';
import BaseOption from '../Option';
import {mixins} from '../styles';

type TPeriodPickerProps = {
  isOpen?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  showInput?: boolean;
};

export const PeriodPicker = styled.div<TPeriodPickerProps>`
  ${({showInput}: TPeriodPickerProps) => showInput && mixins.input}
  ${mixins.flexAlign('flex-start', 'center')}
`;

export const CalendarIcon = styled(BaseCalendarIcon)`
  ${mixins.wh('20px')}
  flex-shrink: 0;
`;

export const Value = styled.div`
  flex: 1 1 auto;
  padding: ${({theme}) => `0 ${theme.spacing.s1} 0 ${theme.spacing.s3}`};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ArrowIcon = styled(KeyboardArrowDownIcon)`
  ${mixins.wh('20px')}
  flex-shrink: 0;
`;

export const Option = styled(BaseOption)`
  cursor: pointer;
`;

export const Calendar = styled(BaseCalendar)`
  overflow: hidden;
`;

export const Overlay = styled(BaseOverlay)`
  overflow: hidden;
  padding: 0;
`;
